import { render } from "./VipForm.vue?vue&type=template&id=20625df5&scoped=true"
import script from "./VipForm.vue?vue&type=script&lang=js"
export * from "./VipForm.vue?vue&type=script&lang=js"

import "./VipForm.vue?vue&type=style&index=0&id=20625df5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20625df5"]])

export default __exports__